import React from "react";
import icon_user from "../../assets/icons/icon-user.svg";
import icon_mail from "../../assets/icons/icon-mail.svg";
import { useAuthContext } from "../../context/providers/AuthContext";
import PhoneInput from "react-phone-input-2";
import startsWith from "lodash.startswith";
import "react-phone-input-2/lib/bootstrap.css";

const InformationForm = ({ userAuthenticated }) => {
	/***Init user state */

	const [user, setUser] = React.useState({
		firstName: userAuthenticated.firstName || "",
		lastName: userAuthenticated.lastName || "",
		email: userAuthenticated.email || "",
		phoneNumber: userAuthenticated.phoneNumber || "",
		country: userAuthenticated.country || "",
	});

	//init profile button state
	const [enableProfileButton, setEnableProfileButton] = React.useState(true);
	const { firstName, lastName, email, phoneNumber } = user;
	const { updateProfile } = useAuthContext();

	/**Methods */

	//1 - handle form change state
	const onChange = (e) => {
		setUser({ ...user, [e.target.name]: e.target.value });
		if (firstName === "" && lastName === "" && email === "" && phoneNumber === "") {
			setEnableProfileButton(true);
		} else {
			setEnableProfileButton(false);
		}
	};

	//Handle form submit
	const handleSubmit = (e) => {
		e.preventDefault();
		updateProfile(userAuthenticated?._id, user);
		setEnableProfileButton(true);
	};

	return (
		<form onSubmit={handleSubmit}>
			<div className="d-md-flex">
				<div className="input__field mt-3 w-100 mt-md-4">
					<label htmlFor="name" className="input__label">
						Firstname
					</label>
					<div className="input__group">
						<input type="text" name="firstName" className="input input--primary input--with_icon" value={firstName} autoComplete="name" onChange={onChange} required />
						<div className="input__icon d-flex align-items-center justify-content-center">
							<img src={icon_user} alt="" />
						</div>
					</div>
				</div>
				<div className="input__field mt-3 w-100 mt-md-4 ml-md-3">
					<label htmlFor="second_name" className="input__label">
						Lastname
					</label>
					<div className="input__group">
						<input type="text" name="lastName" className="input input--primary input--with_icon" value={lastName} autoComplete="family-name" onChange={onChange} required />
						<div className="input__icon d-flex align-items-center justify-content-center">
							<img src={icon_user} alt="" />
						</div>
					</div>
				</div>
			</div>
			<div className="d-md-flex">
				<div className="input__field mt-3 w-100 mt-md-4">
					<label htmlFor="email" className="input__label">
						Email
					</label>
					<div className="input__group">
						<input type="email" name="email" className="input input--primary input--with_icon" value={email} autoComplete="email" onChange={onChange} required />
						<div className="input__icon d-flex align-items-center justify-content-center">
							<img src={icon_mail} alt="" />
						</div>
					</div>
				</div>
				<div className="input__field mt-3 w-100 mt-md-4 ml-md-3">
					<label htmlFor="tel" className="input__label">
					 WhatsApp number
					</label>

					{
						<PhoneInput
							inputClass="input input--primary input--phoneInput"
							inputProps={{
								name: "phone",
								required: true,
								autoFocus: true,
							}}
							placeholder="Numero de phone"
							country={"us"}
							value={phoneNumber}
							isValid={(inputNumber, country, countries) => {
								return countries.some((country) => {
									return startsWith(inputNumber, country.dialCode) || startsWith(country.dialCode, inputNumber);
								});
							}}
							onChange={(value, country, e, formattedValue) => {
								setEnableProfileButton(false);
								setUser({ ...user, phoneNumber: formattedValue, country: country.name });
							}}
						/>
					}
				</div>
			</div>
			<div className="d-md-flex">
				{/*<div className="input__field mt-3 w-100 mt-md-4">
					<label htmlFor="tel" className="input__label">
						Numéro WhatsApp
					</label>
					<div className="input__group">
						<input
							type="tel"
							name="phoneNumber"
							className="input input--primary input--with_icon"
							value={phoneNumber}
							onChange={onChange}
							required
						/>

						<div className="input__icon d-flex align-items-center justify-content-center">
							<img src={icon_user} alt="" />
						</div>
					</div>
				</div>*/}
				<div className="ml-md-3 w-100"></div>
			</div>
			<div className="d-flex justify-content-center mt-5">
				<button type="submit" className="btn btn--primary w-100" disabled={enableProfileButton}>
					Submit
				</button>
			</div>
		</form>
	);
};

export default InformationForm;
